function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(n); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React, { useRef, useState } from 'react';
import cn from 'classnames';
import { string, any, func, oneOfType, shape } from 'prop-types';
import FormInput from '../../atoms/FormInput';
import { useOnClickOutside } from '../../hooks';
import { debounce, getIndexFromKeycode } from '../../utils';
import Link from '../../atoms/Link';
/**
 * FormAutocomplete component.
 */

var _ref2 = /*#__PURE__*/React.createElement("div", {
  className: "form-autocomplete__list-item form-autocomplete__no-options-item body-copy-small"
}, "No result");

var FormAutocomplete = function FormAutocomplete(_ref) {
  var _options$selected2;

  var className = _ref.className,
      name = _ref.name,
      formInputRef = _ref.formInputRef,
      autocomplete = _ref.autocomplete,
      onChange = _ref.onChange,
      restProps = _objectWithoutProperties(_ref, ["className", "name", "formInputRef", "autocomplete", "onChange"]);

  var dropdownRef = useRef();

  var _useState = useState(-1),
      _useState2 = _slicedToArray(_useState, 2),
      selected = _useState2[0],
      setSelected = _useState2[1];

  var _useState3 = useState(false),
      _useState4 = _slicedToArray(_useState3, 2),
      showDropdown = _useState4[0],
      setShowDropdown = _useState4[1];

  var _useState5 = useState([]),
      _useState6 = _slicedToArray(_useState5, 2),
      options = _useState6[0],
      setOptions = _useState6[1];

  var listBoxId = "".concat(name, "-listbox");
  var minimumCharacters = 3;
  var searchByText = debounce(function (input) {
    autocomplete(input).then(function (res) {
      return res.input === formInputRef.current.value && setOptions(res.results);
    }).catch(function () {
      return setShowDropdown(false);
    }); // rejected request
  }, 300);
  /**
   * Handle a change of text in the search input.
   */

  var onTextInputChange = function onTextInputChange(evt) {
    var value = evt.target.value;
    var hasEnoughChars = value.length >= minimumCharacters;
    setSelected(-1);

    if (hasEnoughChars) {
      searchByText(value);
    }

    setShowDropdown(hasEnoughChars);
    onChange(evt);
  };

  var onTextInputKeyDown = function onTextInputKeyDown(e) {
    var keyCode = e.keyCode; // Skip other than related key actions

    if (![40, 38, 36, 35, 13, 27, 9].includes(keyCode)) {
      return;
    }

    if (!showDropdown) {
      // Down - open dropdown
      if (keyCode === 40) {
        setShowDropdown(true);
        setSelected(0);
      } // From here on are only dropdown related key actions


      return;
    } // Esc, tab - Close the dropdown


    if (keyCode === 27 || keyCode === 9) {
      setShowDropdown(false);
      return;
    } // Enter - Open selected


    if (keyCode === 13 && selected >= 0) {
      var _options$selected;

      window.open((_options$selected = options[selected]) === null || _options$selected === void 0 ? void 0 : _options$selected.url);
      return;
    } // Select next option in dropdown


    var lastIndex = options.length - 1;
    var nextIndex = getIndexFromKeycode(keyCode, selected, lastIndex);
    setSelected(nextIndex);
  }; // Hide on click outside the dropdown.


  useOnClickOutside(dropdownRef, function () {
    if (!showDropdown) {
      return;
    }

    setShowDropdown(false);
  }, [showDropdown]);

  var listItem = function listItem(option, i) {
    return /*#__PURE__*/React.createElement("li", {
      id: option.id,
      key: option.id,
      className: "form-autocomplete__list-item d-flex" + (selected === i ? " form-autocomplete__list-item--selected" : ""),
      role: "option",
      "aria-selected": selected === i,
      tabIndex: "-1"
    }, /*#__PURE__*/React.createElement(Link, {
      href: option === null || option === void 0 ? void 0 : option.url,
      ellipsis: true,
      onKeyDown: onTextInputKeyDown
    }, option.title));
  };

  return /*#__PURE__*/React.createElement("div", {
    className: cn('form-autocomplete', className)
  }, /*#__PURE__*/React.createElement(FormInput, _extends({}, restProps, {
    ref: formInputRef,
    name: name,
    className: "form-autocomplete__input",
    role: "searchbox",
    "aria-haspopup": "listbox",
    "aria-controls": listBoxId,
    "aria-activedescendant": (_options$selected2 = options[selected]) === null || _options$selected2 === void 0 ? void 0 : _options$selected2.id,
    "aria-label": "Search",
    onChange: onTextInputChange,
    onKeyDown: onTextInputKeyDown,
    autoComplete: "off"
  })), /*#__PURE__*/React.createElement("div", {
    ref: dropdownRef,
    className: 'form-autocomplete__options pt-xxs pb-xxs pl-xs pr-xs' + (showDropdown ? " form-autocomplete__options--visible" : "")
  }, /*#__PURE__*/React.createElement("ul", {
    id: listBoxId,
    className: "ma-reset pa-reset",
    role: "listbox"
  }, options.map(listItem)), !options.length && _ref2));
};

FormAutocomplete.displayName = 'FormAutocomplete';
FormAutocomplete.defaultProps = {
  className: null,
  name: 'autocomplete',
  formInputRef: null,
  autocomplete: null,
  onChange: function onChange() {
    return null;
  }
};
FormAutocomplete.propTypes = process.env.NODE_ENV !== "production" ? {
  /** Additional class names to add to the component root. */
  className: string,

  /** A name for the input. */
  name: string,

  /** A ref for the form input. */
  formInputRef: oneOfType([func, shape({
    current: any
  })]),

  /** A fetch API function. */
  autocomplete: func,

  /** On change event handler */
  onChange: func
} : {};
export default FormAutocomplete;